const isMobile = require('../../viscomjs/utils/isMobile');
import {analyticsEvent} from './../../../analytics';
const adapters = require('./adapters');
const shareButtons = [...document.querySelectorAll('.result__sharing-block .share__item')];
import * as VanillaSharing from 'vanilla-sharing';
import meta from '../../../../data/meta.json';
import share from '../../../../data/share.json';
import data from '../../../../data/basic.json';

const options = {
    url: meta.url,
    redirectUri: undefined,
    title: meta.title,
    description: meta.description,
    hashtag: undefined,
    image: `${meta.url}/img/${meta.image}`,
    media: `${meta.url}/img/${meta.image}`,
    isVkParse: false,
    fbAppId: meta.fbappid
};

const shareOptions = {
    url: options.url,
    redirectUri: options.redirectUri,
    title: options.title,
    description: options.description,
    hashtag: options.hashtag,
    image: options.image,
    media: options.media,
    isVkParse: options.isVkParse,
    fbAppId: options.fbAppId
};

export class CardControllerAdapter {
    constructor() {
        this._body = document.body;
        this._header = document.querySelector('.header');
        this._points = [...document.querySelectorAll('.point')];
        this._cardblock = document.querySelector('.card-block');
        this._card = document.querySelector('.card');
        this._personDescription = document.querySelector('.card__person-description span');
        this._personAvatar = document.querySelector('.card__person-avatar img');
        this._questionNumber = document.querySelector('.card__question-counter-current');
        this._question = document.querySelector('.card__question h3');
        this._answerButtons = [...document.querySelectorAll('.card .answers__answer')];
        this._answerButtonsText = [...document.querySelectorAll('.card .answers__answer-text')];
        this._answerButton = document.querySelector('.card .card__button');
        this._answerButtonText = document.querySelector('.card .card__button span');
        this._closePrewiewButton = document.querySelector('.card__preview-button');
        this._ballsCountContainer = document.querySelector('.balls-count-container');
        this._ballBlock = document.querySelector('.ball-block');

        this._resultBlock = document.querySelector('.result');
        this._resultBalls = document.querySelector('.result__description-points--result');
        this._resultBallsAll = document.querySelector('.result__description-points--allquestions');
        this._resultWinText = document.querySelector('.result__description-text');
        this._resultImg = document.querySelector('.result__image img');
        this._resultShareContainer = document.querySelector('.result__description-buttonblock');
        this._resultShareTrigger = document.querySelector('.result__share-button');

        this._currentQuestion = 0;
        this._totalPoints = 0;
        this._questions = data.qna;

        this._imageSlides = [...document.querySelectorAll('.mobile-map-container .slide')];
        this._mobileMapContainer = document.querySelector('.mobile-map-container');
        this._startAgainButton = document.querySelector('.result__start-again-button');
    }

    clickPoint(index) {
        if (this._body.dataset.cardOpened === 'true') {
            return;
        }
        this.setQuestion(+index);
        this.openBlock();
        if (!isMobile.check()) {
            adapters.DragController().scaleMap(index);
            adapters.DragController().disable();
        }
    }

    showNextQuestion(index) {
        this._points.forEach(point => {
            point.classList.remove('show');
        });
        if (index < this._points.length) {
            this._points[index].classList.add('show');
            this._points[index].classList.add('active');
        }
        if (index > 0) {
            this._points[index - 1].classList.remove('active');
        }
    }

    closePreview() {
        this._cardblock.classList.remove('show');
        this.setQuestion(0);
        this.showNextQuestion(this._currentQuestion);
        document.querySelector('.card__preview').classList.add('hidden');
        document.querySelector('.card__description-block').classList.remove('hidden');
        document.querySelector('.card__answer-block').classList.remove('hidden');
        analyticsEvent('Test', 'click', 'Test start pressed');
    }

    showPreview() {
        this._cardblock.classList.add('show');
    }

    showBalls() {
        this._ballBlock.classList.add('show');
    }

    showResults() {
        let result = 'win';
        let resultCount = 2;
        const resultsData = data.result;
        this._resultBlock.classList.add('show');
        this._resultBalls.innerHTML = this._totalPoints;
        this._resultBallsAll.innerHTML = data.qna.length * 2;
        /*
        this._resultBlock
        this._resultBalls
        this._resultBallsAll
        this._resultWinText
        this._resultImg
        */
        if (this._totalPoints < 14 && this._totalPoints > 6) {
            result = 'neutral';
            resultCount = 1;
            this._resultBalls.innerHTML += ' баллов ';
        } else if (this._totalPoints <= 6) {
            result = 'lose';
            resultCount = 0;
            if (this._totalPoints === 1) {
                this._resultBalls.innerHTML += ' балл ';
            } else if (this._totalPoints === 0 || this._totalPoints > 4) {
                this._resultBalls.innerHTML += ' баллов ';
            } else {
                this._resultBalls.innerHTML += ' балла ';
            }
        } else {
            this._resultBalls.innerHTML += ' баллов ';
        }
        this._resultWinText.innerHTML = resultsData[result].text;
        if (result === 'win') {
            this._resultBallsAll.innerHTML += '. Бинго!';
        }
        const image = new Image();
        image.src = resultsData[result].image;
        this._resultImg.src = image.src;
        shareOptions.url += `share.php?type=${resultCount}`;
        shareOptions.title = share[resultCount].title;
        shareOptions.description = share[resultCount].description;
        shareOptions.image = 'http://businesscard.lenta.ru/img/share/' + share[resultCount].image;
        analyticsEvent('Test', 'click', `Test endet with ${this._totalPoints} points`);
    }

    restartTest() {
        this._totalPoints = 0;
        this._ballsCountContainer.innerHTML = this._totalPoints;
        if (!isMobile.check()) {
            this._currentQuestion = 0;
            this.setQuestion(0);
        }
        this._points.forEach(point => {
            point.classList.remove('active');
        });
        this.showNextQuestion(this._currentQuestion);
        this._resultBlock.classList.remove('show');
        if (!isMobile.check()) {
            adapters.DragController().unscaleMap();
            adapters.DragController().enable();
            adapters.DragController().gotoNextPoint();
        }
        this._resultShareContainer.classList.add('show-share');
        analyticsEvent('Test', 'click', 'Test restarted');
    }

    closeBlock() {
        this._cardblock.classList.remove('show');
        this._currentQuestion = this._currentQuestion + 1;
        if (this._currentQuestion < this._points.length) {
            this.showNextQuestion(this._currentQuestion);
            if (!isMobile.check()) {
                adapters.DragController().unscaleMap();
                adapters.DragController().enable();
                adapters.DragController().gotoNextPoint();
            }
        } else {
            this.showResults();
        }

        if (isMobile.check()) {
            switch (this._currentQuestion) {
                case 4:
                    this._mobileMapContainer.dataset.image = 1;
                    break;
                case 5:
                    this._mobileMapContainer.dataset.image = 2;
                    break;
                case 6:
                    this._mobileMapContainer.dataset.image = 3;
                    break;
                case 7:
                    this._mobileMapContainer.dataset.image = 4;
                    break;
                case 9:
                    this._mobileMapContainer.dataset.image = 5;
                    break;
                case 10:
                    this._mobileMapContainer.dataset.image = 0;
                    this._currentQuestion = 0;
                    this.showNextQuestion(this._currentQuestion);
                    break;
                default:
            }
        }
    }

    openBlock() {
        this._cardblock.classList.add('show');
    }

    setQuestion(index) {
        const currentQuestion = this._questions[+index];
        this._answerButtons.forEach((button, answerIndex) => {
            button.classList.remove('active');
            button.dataset.question = index;
            button.dataset.answer = answerIndex;
        });
        this._answerButton.classList.add('block');
        this._answerButtonsText.forEach((textblock, index) => {
            textblock.innerHTML = `${+index + 1} ${currentQuestion.answers[+index].text}`;
        });
        this._questionNumber.innerHTML = `${+index + 1} `;
        this._personDescription.innerHTML = currentQuestion.description;
        this._question.innerHTML = currentQuestion.question;

        const avatar = new Image();
        avatar.src = currentQuestion.avatar;
        this._personAvatar.src = avatar.src;

        if (this._currentQuestion + 1 === this._points.length) {
            this._answerButtonText.innerHTML = 'Узнать результат';
        } else {
            this._answerButtonText.innerHTML = 'Мой ответ';
        }
    }

    activateAnswer(button) {
        this._answerButtons.forEach(buttonInst => {
            if (button !== buttonInst) {
                buttonInst.classList.remove('active');
            } else {
                buttonInst.classList.add('active');
            }
        });
        this._answerButton.classList.remove('block');
    }

    checkAnswer() {
        let points;
        this._answerButtons.forEach(button => {
            if (button.classList.contains('active')) {
                points = this._questions[button.dataset.question].answers[button.dataset.answer].points;
            }
        });
        this._totalPoints = +points + this._totalPoints;
        this._ballsCountContainer.innerHTML = this._totalPoints;
        this.closeBlock();
        analyticsEvent('Test', 'click', `Question number: ${this._currentQuestion + 1} clicked`);
    }

    resizeCardBlock() {
        const headerHeight = this._header.offsetHeight;
        this._card.style.maxHeight = window.innerHeight - headerHeight + 'px';
        this._cardblock.style.paddingTop = headerHeight + 'px';
    }

    init() {
        this._body.dataset.cardOpened = false;
        //  let delta = 0;
        this._points.forEach(point => {
            point.addEventListener('click', () => {
                this.clickPoint(point.dataset.point);
            });
        });

        this._answerButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.activateAnswer(button);
            });
        });
        document.querySelector('.card__question-counter-all').innerHTML = this._questions.length;
        // this.showPreview();

        this._closePrewiewButton.addEventListener('click', () => {
            this.closePreview();
            this.showBalls();
        });

        this._answerButton.addEventListener('click', () => {
            this.checkAnswer();
        });

        this._startAgainButton.addEventListener('click', () => {
            this.restartTest();
        });

        this._ballsCountContainer.innerHTML = this._totalPoints;

        this._resultShareTrigger.addEventListener('click', () => {
            this._resultShareContainer.classList.add('show-share');
            analyticsEvent('Test', 'click', 'Share trigger pressed');
        });

        shareButtons.forEach(button => {
            const social = button.dataset.social;
            const isNativeShare = social === 'all' && navigator.share !== undefined;

            if (isNativeShare) {
                button.classList.add('share__item--show');
            }

            button.addEventListener('click', () => {
                if (isNativeShare) {
                    navigator.share({
                        title: shareOptions.title,
                        url: shareOptions.url
                    });
                } else {
                    VanillaSharing[social](shareOptions);
                }
            });
        });

        if (isMobile.check()) {
            this.resizeCardBlock();
            window.addEventListener(
                'resize',
                () => {
                    this.resizeCardBlock();
                },
                false
            );
            window.addEventListener('orientationchange', () => {
                this.resizeCardBlock();
            });
        }

        /*
        this._closeblock.addEventListener('click', () => {
            this.closeBlock();
        });
        */
    }
}
